module.exports = __webpack_public_path__ + "img/icon_card012.c962a7f5.png";